import { newIcons } from '@web/walter-ui-kit'
import s from './s.module.css'
import { Transaction } from '~pages/CardsPage/Cards/Transactions/types'

export const getTxSvgName = (type: Transaction['transaction_type']) => {
    if (type === 'deposit') {
        return newIcons.ic24ArrowDown
    }
    if (type === 'payment') {
        return newIcons.ic24ArrowUp
    }

    return undefined
}

export const getAmountClassName = (type: Transaction['transaction_type'], status: Transaction['status']) => {
    if (
        type === 'deposit' &&
        (status === 'Cleared' ||
            status === 'Settled' ||
            status === 'Refunded' ||
            status === 'Chargeback' ||
            status === 'Authorized')
    ) {
        return s.amountSuccess
    }

    if (status === 'Declined' || status === 'Reversed') {
        return s.amountError
    }

    return undefined
}
